import Component from './component';
import quickviewHelper from '../helpers/quickviewhelper';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');

export default class quickView extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }

    getModalContent(url) {
        fetch(url + '&showQuickView=true', {
            method: 'GET',
            headers: {"Content-type": "application/json;charset=UTF-8", "X-Requested-With": "XMLHttpRequest"}
        })
        .then((response) => response.json())
            .then((data) => {
                this.setState(data);
            });
    }

    getCQViewproductActivity() {
        if (this.el.dataset.activityUrl) {
            const pid = (new URL(location.origin + this.el.dataset.modalUrl)).searchParams.get('pid');
            var scriptContainer = this.$el.find('.CQviewproductScript');
            fetch(this.el.dataset.activityUrl + `?pid=${pid}`)
            .then((response) => {
                return response.text().then(data => {
                    scriptContainer.empty().html(data);
                });
            });
        }
    }

    openModal() {
        if ($('.product-set-detail').length) {
            $('body').append(quickviewHelper.getModalHtmlElementSet(`${this.name}Modal`));
        } else {
            $('body').append(quickviewHelper.getModalHtmlElement(`${this.name}Modal`));
        }
        this.getModalContent(this.el.dataset.modalUrl);
    }

    render() {
        const data = this.state;
        const $container = $(`#${this.name}Modal`);
        const recommendationContainer = this.$el.closest('div[data-recomtype]');
        const recommendationContainerType = recommendationContainer ? recommendationContainer.data('recomtype') : '';
        const searchRedirect = this.$el.closest('div.quickview').data('searchcheck');
        const productTileIndex = this.$el.closest('.productTileShow').data('productindex');
        this.getCQViewproductActivity();
        quickviewHelper.renderQuickView(data, $container, recommendationContainerType, true);
        // tealium event
        tealiumEnable.getAnalyticsData('quickViewEvent', data, productTileIndex, searchRedirect);
    }

    enable() {
        // click binding on modal button
        $(this.$el).on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (this.el.dataset.stayopen === 'true') {
                $(`#${this.el.dataset.comp}Modal .modal-dialog`).spinner().start();
                this.getModalContent(this.el.dataset.modalUrl);
                this.el.scrollIntoView({block: 'center'});
            } else {
                this.openModal();
            }
        });

        $(this.$el).on('keyup', (event) => {
            if (event.key === 'Enter' && this.el.dataset.stayopen) {
                $(this.$el).trigger('click');
            }
        });

        // remove modal once closed
        $('#quickViewModal').on('hidden.bs.modal', (event) => {
            $(event.target).remove();
        });
    }
}
